import type { InputHTMLAttributes } from 'react';

import styles from './Field.module.css';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

// Текстовое поле формы — единый стиль/focus-состояние через токены.
export function Input({ className, ...rest }: InputProps): JSX.Element {
  return <input className={[styles.control, className].filter(Boolean).join(' ')} {...rest} />;
}
